import type * as React from "react";
import { useState } from "react";

import { styled, TextField, type TextFieldProps, Box } from "~/common/mui";
import { Icon } from "../icon/Icon";
import { type IconType } from "../icon/IconType";
import { C_PRIMARY, C_PRIMARY_DISABLED } from "../icon/Colors";
import { FONT_RAW_SIZES, FontSize } from "./Fonts";

export interface PasswordInputProps extends Omit<TextFieldProps, "variant"> {
  isHighlight?: boolean;
  iconType: IconType;
  iconTypeAfterClick: IconType;
  helperLabel?: React.ReactNode;
  shrink?: boolean;
}

const StyledWrapper = styled(Box)({
  position: "relative",
  "& input": {
    cursor: "auto",
  },
  width: "100%",
});

interface StyledIconProps {
  disabled?: boolean;
  noLabel?: boolean;
}

const StyledIcon = styled(Icon, {
  shouldForwardProp: (prop) => prop !== "disabled" && prop !== "noLabel",
})<StyledIconProps>(({ disabled, noLabel }) => ({
  lineHeight: FONT_RAW_SIZES[FontSize.BodyMedium].lineHeight + "px",
  color: disabled ? C_PRIMARY_DISABLED : C_PRIMARY,
  cursor: disabled ? "default" : "pointer",
  ...(noLabel && { top: "8px" }),
}));

export const PasswordInput: React.FC<PasswordInputProps> = (props) => {
  const { iconType, iconTypeAfterClick, value, onChange, inputRef, name, ...inputProps } = props;

  const [iconClicked, setIconClicked] = useState<boolean>(false);

  const onEyeClick = () => setIconClicked((prev) => !prev);

  return (
    <StyledWrapper>
      <TextField
        fullWidth
        value={value}
        onChange={onChange}
        name={name}
        inputRef={inputRef}
        type={iconClicked ? "text" : "password"}
        helperText={inputProps.helperLabel}
        InputLabelProps={{ shrink: inputProps.shrink }}
        InputProps={{
          endAdornment: (
            <span onClick={inputProps.disabled ? undefined : onEyeClick}>
              <StyledIcon
                type={iconClicked ? iconTypeAfterClick : iconType}
                disabled={inputProps.disabled}
                noLabel={!inputProps.label}
              />
            </span>
          ),
        }}
        {...inputProps}
      />
    </StyledWrapper>
  );
};

export default PasswordInput;
